// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.additional_info {
  background-color: #313131;
}
.additional_info .container_additional_info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
@media screen and (max-width: 767px) {
  .additional_info .container_additional_info {
    grid-template-columns: repeat(1, 1fr);
    padding-bottom: 30px;
  }
}
.additional_info .container_additional_info .checkbox .checkbox_message {
  display: none;
}
@media screen and (max-width: 480px) {
  .additional_info .container_additional_info .card_additional_info .widget_theme_wrapper {
    margin-bottom: 30px;
  }
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .control_link .theme_button {
  background-color: rgb(40, 71, 34);
  border: 2px solid rgb(40, 71, 34);
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .control_link .theme_button:hover {
  background-color: transparent;
  color: rgb(40, 71, 34);
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .widget_title {
  color: rgb(255, 255, 255);
  font-family: "Century Gothic";
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.2rem;
  text-align: center;
  text-transform: uppercase;
}
@media screen and (max-width: 991px) {
  .additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .widget_title {
    padding: 0 10px;
    line-height: 2.5rem;
  }
}
@media screen and (max-width: 480px) {
  .additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .widget_title {
    font-size: 1.25rem;
    line-height: 1.2em;
  }
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .widget_image {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.additional_info .container_additional_info .card_additional_info .widget_theme_wrapper .widget .widget_image img {
  max-width: 8vw;
}
.additional_info .card_additional_info:nth-child(odd) {
  margin-top: 30px;
}
.additional_info .modal_window[data-visible=true] {
  display: flex;
  justify-content: center;
  align-items: center;
}
.additional_info .modal_window[data-visible=true] .modal_form_contact {
  width: 600px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
}
.additional_info .modal_window[data-visible=true] .modal_form_contact .modal_header {
  height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.additional_info .modal_window[data-visible=true] .modal_form_contact .modal_header .btn_close_contact {
  margin: 5px;
  background: none;
  border: none;
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: rgb(0, 0, 0);
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  cursor: pointer;
}
.additional_info .modal_window[data-visible=true] .modal_form_contact .modal_body {
  text-align: center;
  color: rgb(60, 60, 60);
  font-family: "Roboto-Regular";
  font-size: 17px;
  line-height: 3rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/AdditionalInfoBlock/AdditionalInfoBlock.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AATA;EACI,yBAAA;AAWJ;AATI;EACI,aAAA;EACA,qCAAA;AAWR;AATQ;EAJJ;IAKQ,qCAAA;IACA,oBAAA;EAYV;AACF;AARY;EACG,aAAA;AAUf;AAHgB;EAFJ;IAGQ,mBAAA;EAMlB;AACF;AAJgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAMpB;AAHwB;EACI,iCAAA;EACA,iCAAA;AAK5B;AAFwB;EACI,6BAAA;EACA,sBAAA;AAI5B;AAAoB;EACI,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAExB;AAAwB;EATJ;IAUQ,eAAA;IACA,mBAAA;EAG1B;AACF;AADwB;EAdJ;IAeQ,kBAAA;IACA,kBAAA;EAI1B;AACF;AADoB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAGxB;AADwB;EACI,cAAA;AAG5B;AAKI;EACK,gBAAA;AAHT;AAOI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AALR;AAOQ;EACI,YAAA;EAGA,oCAAA;EACA,mBAAA;AAPZ;AASY;EACI,YAAA;EACA,2CAAA;AAPhB;AASgB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAPpB;AAWY;EACI,kBAAA;EAEA,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAVhB","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.additional_info {\n    background-color: #313131;\n\n    .container_additional_info {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n\n        @media screen and (max-width: 767px) {\n            grid-template-columns: repeat(1, 1fr);\n            padding-bottom: 30px;\n        }\n\n        .checkbox {\n\n            .checkbox_message {\n               display: none;\n            }\n        }\n\n        .card_additional_info {\n            .widget_theme_wrapper {\n\n                @media screen and (max-width: 480px) {\n                    margin-bottom: 30px;\n                }\n\n                .widget {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    flex-direction: column;\n    \n                    .control_link{\n                        .theme_button {\n                            background-color: rgb(40, 71, 34);\n                            border: 2px solid rgb(40, 71, 34);\n                        }\n    \n                        .theme_button:hover {\n                            background-color: transparent;\n                            color: rgb(40, 71, 34);\n                          }\n                    }  \n    \n                    .widget_title {\n                        color: rgb(255, 255, 255);\n                        font-family: \"Century Gothic\";\n                        font-size: 1.8rem;\n                        font-weight: 600;\n                        line-height: 1.2rem;\n                        text-align: center;\n                        text-transform: uppercase;\n\n                        @media screen and (max-width: 991px) {\n                            padding: 0 10px;\n                            line-height: 2.5rem;\n                        }\n\n                        @media screen and (max-width: 480px) {\n                            font-size: 1.25rem;\n                            line-height: 1.2em;\n                        }\n                    }\n    \n                    .widget_image {\n                        display: flex;\n                        justify-content: center;\n                        margin-bottom: 30px;\n    \n                        img {\n                            max-width: 8vw;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .card_additional_info:nth-child(odd) {\n         margin-top: 30px;\n        // border: 3px solid red;\n    }\n\n    .modal_window[data-visible=\"true\"] {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .modal_form_contact {\n            width: 600px;\n            // margin: 30px auto;\n            // padding: 0 0 20px 0;\n            background-color: rgb(255, 255, 255);\n            border-radius: 10px;\n\n            .modal_header {\n                height: 30px;\n                border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n\n                .btn_close_contact {\n                    margin: 5px;\n                    background: none;\n                    border: none;\n                    float: right;\n                    font-size: 21px;\n                    font-weight: 700;\n                    line-height: 1;\n                    color: rgb(0, 0, 0);\n                    text-shadow: 0 1px 0 #fff;\n                    opacity: .2;\n                    cursor: pointer;\n                }\n            }\n\n            .modal_body {\n                text-align: center;\n                // padding: 15px;\n                color: rgb(60, 60, 60);\n                font-family: \"Roboto-Regular\";\n                font-size: 17px;\n                line-height: 3rem;\n                font-weight: 600;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
